import { render, staticRenderFns } from "./SearchLeads.vue?vue&type=template&id=048a1980&scoped=true&"
import script from "./SearchLeads.vue?vue&type=script&lang=js&"
export * from "./SearchLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a1980",
  null
  
)

export default component.exports